export default {
    BANKLOAN: "bankloan",
    RIC: "ric"
}
